import { ORDER_METHODS, RoomServiceLocationType } from '../../../../services/exports/Constants';

export default {
  text: {
    thank_you: 'Danke, {{name}}',
    confirmation_email:
      'Du erhältst bald eine Bestätigungs-E-Mail mit deiner Bestellnummer von unserem Technik-Partner {{provider_email}}',
    need_help: 'Hilfe oder Änderungen? Nur per Anruf',
  },
  labels: {
    order_number: 'Bestell Nr: {{number}}',
    restaurant: 'Restaurant',
    order_details: 'Bestell Info',
    contact: 'Kontakt',
    payment_method: 'Zahlungsmethode',
    delivery: 'Lieferung',
    billing_info: 'Zahlungsinfo',
    order_summary: 'Bestellübersicht',
  },
  order_methods: {
    [ORDER_METHODS.PICKUP]: 'Abholbestellung',
    [ORDER_METHODS.DELIVERY]: 'Lieferbestellung',
    [ORDER_METHODS.ROOM_SERVICE]: {
      [RoomServiceLocationType.RoomService]: 'Zimmerservice',
      [RoomServiceLocationType.TableService]: 'Tischbestellung',
    },
  },
  room_service_details: {
    [RoomServiceLocationType.RoomService]: '(Zimmer #{{details}})',
    [RoomServiceLocationType.TableService]: '(Tisch #{{details}})',
  },
  buttons: {
    back_to_menu: 'Zurück zum Menü',
    back_to_checkout: 'Zurück zur Kasse',
    contact_us: 'Kontaktiere uns {{phone_number}}',
  },
  loading: {
    processing_payment: 'Bitte verlasse nicht die Seite, während wir deine Zahlung bearbeiten',
  },
  success_messages: {
    order_placed: {
      title: '✅ Bestellung erfolgreich!',
      description: 'Deine Bestellung wurde erfolgreich aufgegeben.',
    },
  },
  error_messages: {
    failed_to_load: 'Die Bestellung konnte nicht geladen werden. Bitte versuchen Sie es erneut.',
    payment_failed: 'Zahlung fehlgeschlagen, bitte versuchen Sie es erneut',
  },
};
